import React, { forwardRef, useEffect, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import styles from './draw-signature.module.scss';

const DrawSignature = forwardRef(function DrawSignature(_, ref) {
    const [canvasSize, setCanvasSize] = useState({ width: 1066, height: 400 });

    useEffect(() => {
        const updateCanvasSize = () => {
            const canvas = ref.current.getCanvas()
            const width = canvas.offsetWidth; // 90% of the viewport width
            // 8:3 on desktop; taller (2:1) on phones so there is room to sign with a finger
            const height = width < 600 ? width / 2 : width / (8 / 3);
            setCanvasSize({ width, height });
        };

        // Set initial size
        updateCanvasSize();

        // Listen for window resize
        window.addEventListener('resize', updateCanvasSize);

        // Cleanup the event listener on component unmount
        return () => window.removeEventListener('resize', updateCanvasSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <SignatureCanvas
            ref={ref}
            canvasProps={{
                width: canvasSize.width,
                height: canvasSize.height,
                className: `${styles.sigCanvas}`
            }}
        />
    )
})

export default DrawSignature